// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `  .wb-footer {
    position: relative;
    overflow: hidden;
    background: linear-gradient(135deg, #07131f 0%, #0b1c2d 50%, #09111c 100%);
    color: white;
    padding-top: 80px;
    border-top: 1px solid rgba(255,255,255,0.08);
  }
  
  /* glow */
  .wb-footer-glow{
    position:absolute;
    inset:0;
    background:
      radial-gradient(circle at 20% 20%, rgba(28,122,180,.18), transparent 35%),
      radial-gradient(circle at 80% 40%, rgba(243,90,14,.15), transparent 35%),
      radial-gradient(circle at 50% 100%, rgba(28,122,180,.12), transparent 45%);
    filter: blur(80px);
    pointer-events:none;
  }
  
  .wb-footer-content{
    position:relative;
    z-index:2;
    width:90%;
    max-width:1400px;
    margin:auto;
    display:grid;
    grid-template-columns: 2fr 1fr 1fr 1fr;
    gap:60px;
    padding-bottom:50px;
  }
  
  /* brand */
  .wb-footer-brand img{
    width:180px;
    margin-bottom:20px;
  }
  
  .wb-footer-brand p{
    color:#c7d2de;
    line-height:1.8;
    max-width:420px;
    font-size:15px;
  }
  
  /* columns */
  .wb-footer-column h3{
    margin-bottom:22px;
    font-size:20px;
    color: var(--primary-100);
    position:relative;
  }
  
  .wb-footer-column h3::after{
    content:"";
    position:absolute;
    left:0;
    bottom:-8px;
    width:50px;
    height:3px;
    border-radius:10px;
    background: var(--primary-100);
    /* background: linear-gradient(90deg,#1c7ab4,#f35a0e); */
  }
  
  .wb-footer-column a,
  .wb-footer-column p{
    display:block;
    text-decoration:none;
    color:#d7e1eb;
    margin-bottom:14px;
    transition:.25s;
    width:fit-content;
  }
  
  .wb-footer-column a:hover{
    color:#f35a0e;
    transform:translateX(6px);
  }
  
  /* socials */
  .wb-footer-socials{
    display:flex;
    gap:15px;
    margin-top:25px;
  }
  
  .wb-footer-socials a{
    width:45px;
    height:45px;
    border-radius:50%;
    display:flex;
    align-items:center;
    justify-content:center;
    color:white;
    font-size:18px;
    text-decoration:none;
    background: rgba(255,255,255,.06);
    border:1px solid rgba(255,255,255,.1);
    backdrop-filter: blur(10px);
    transition:.3s;
  }
  
  .wb-footer-socials a:hover{
    transform:translateY(-6px) scale(1.08);
    background: var(--primary-100);
    /* background: linear-gradient(135deg,#1c7ab4,#f35a0e); */
    box-shadow:0 0 25px rgba(243,90,14,.35);
  }
  
  /* bottom */
  .wb-footer-bottom{
    position:relative;
    z-index:2;
    text-align:center;
    padding:25px;
    border-top:1px solid rgba(255,255,255,.08);
    color:#9fb1c3;
    font-size:14px;
    background: rgba(255,255,255,.02);
  }
  
  /* responsive */
  @media(max-width:1000px){
    .wb-footer-content{
      grid-template-columns:1fr 1fr;
      gap:40px;
    }
  }
  
  @media(max-width:700px){
    .wb-footer{
      padding-top:50px;
    }
  
    .wb-footer-content{
      grid-template-columns:1fr;
      text-align:center;
    }
  
    .wb-footer-brand p{
      margin:auto;
    }
  
    .wb-footer-socials{
      justify-content:center;
    }
  
    .wb-footer-column a,
    .wb-footer-column p{
      margin-inline:auto;
    }
  
    .wb-footer-column h3::after{
      left:50%;
      transform:translateX(-50%);
    }
  }

.wb-footer { background:#020617; border-top:1px solid rgba(103,232,249,.18); padding-top:100px; }.wb-footer-glow { background:radial-gradient(circle at 15% 15%, rgba(34,211,238,.16), transparent 29%),radial-gradient(circle at 78% 45%, rgba(99,102,241,.18), transparent 31%); }
.wb-footer-brand p,.wb-footer-column a,.wb-footer-column p { color:#9caec5; }.wb-footer-column h3 { color:#a5f3fc; }.wb-footer-column h3::after { height:1px; width:64px; background:linear-gradient(90deg,#22d3ee,transparent); }.wb-footer-column a:hover { color:#67e8f9; }.wb-footer-bottom { border-color:rgba(125,211,252,.13); color:#71829a; }

.wb-footer { border-top-color:rgba(224,148,110,.2); }.wb-footer-glow { background:radial-gradient(circle at 15% 15%,rgba(233,90,19,.16),transparent 29%),radial-gradient(circle at 78% 45%,rgba(78,119,153,.2),transparent 31%); }.wb-footer-brand p,.wb-footer-column a,.wb-footer-column p { color:#94a9ba; }.wb-footer-column h3 { color:#e0946e; }.wb-footer-column h3::after { background:linear-gradient(90deg,#e95a13,transparent); }.wb-footer-column a:hover { color:#e0946e; }.wb-footer-bottom { border-color:rgba(148,169,186,.16); }
`, "",{"version":3,"sources":["webpack://./src/mainwebsite/Components/Footer/Footer.css"],"names":[],"mappings":"EAAE;IACE,kBAAkB;IAClB,gBAAgB;IAChB,0EAA0E;IAC1E,YAAY;IACZ,iBAAiB;IACjB,4CAA4C;EAC9C;;EAEA,SAAS;EACT;IACE,iBAAiB;IACjB,OAAO;IACP;;;gFAG4E;IAC5E,kBAAkB;IAClB,mBAAmB;EACrB;;EAEA;IACE,iBAAiB;IACjB,SAAS;IACT,SAAS;IACT,gBAAgB;IAChB,WAAW;IACX,YAAY;IACZ,sCAAsC;IACtC,QAAQ;IACR,mBAAmB;EACrB;;EAEA,UAAU;EACV;IACE,WAAW;IACX,kBAAkB;EACpB;;EAEA;IACE,aAAa;IACb,eAAe;IACf,eAAe;IACf,cAAc;EAChB;;EAEA,YAAY;EACZ;IACE,kBAAkB;IAClB,cAAc;IACd,yBAAyB;IACzB,iBAAiB;EACnB;;EAEA;IACE,UAAU;IACV,iBAAiB;IACjB,MAAM;IACN,WAAW;IACX,UAAU;IACV,UAAU;IACV,kBAAkB;IAClB,8BAA8B;IAC9B,wDAAwD;EAC1D;;EAEA;;IAEE,aAAa;IACb,oBAAoB;IACpB,aAAa;IACb,kBAAkB;IAClB,eAAe;IACf,iBAAiB;EACnB;;EAEA;IACE,aAAa;IACb,yBAAyB;EAC3B;;EAEA,YAAY;EACZ;IACE,YAAY;IACZ,QAAQ;IACR,eAAe;EACjB;;EAEA;IACE,UAAU;IACV,WAAW;IACX,iBAAiB;IACjB,YAAY;IACZ,kBAAkB;IAClB,sBAAsB;IACtB,WAAW;IACX,cAAc;IACd,oBAAoB;IACpB,iCAAiC;IACjC,qCAAqC;IACrC,2BAA2B;IAC3B,cAAc;EAChB;;EAEA;IACE,sCAAsC;IACtC,8BAA8B;IAC9B,yDAAyD;IACzD,uCAAuC;EACzC;;EAEA,WAAW;EACX;IACE,iBAAiB;IACjB,SAAS;IACT,iBAAiB;IACjB,YAAY;IACZ,0CAA0C;IAC1C,aAAa;IACb,cAAc;IACd,iCAAiC;EACnC;;EAEA,eAAe;EACf;IACE;MACE,6BAA6B;MAC7B,QAAQ;IACV;EACF;;EAEA;IACE;MACE,gBAAgB;IAClB;;IAEA;MACE,yBAAyB;MACzB,iBAAiB;IACnB;;IAEA;MACE,WAAW;IACb;;IAEA;MACE,sBAAsB;IACxB;;IAEA;;MAEE,kBAAkB;IACpB;;IAEA;MACE,QAAQ;MACR,0BAA0B;IAC5B;EACF;;AAEF,aAAa,kBAAkB,EAAE,0CAA0C,EAAE,iBAAiB,EAAE,CAAC,kBAAkB,8JAA8J,EAAE;AACnR,6DAA6D,aAAa,EAAE,CAAC,uBAAuB,aAAa,EAAE,CAAC,8BAA8B,UAAU,EAAE,UAAU,EAAE,qDAAqD,EAAE,CAAC,4BAA4B,aAAa,EAAE,CAAC,oBAAoB,kCAAkC,EAAE,aAAa,EAAE;;AAErV,aAAa,qCAAqC,EAAE,CAAC,kBAAkB,wJAAwJ,EAAE,CAAC,6DAA6D,aAAa,EAAE,CAAC,uBAAuB,aAAa,EAAE,CAAC,8BAA8B,qDAAqD,EAAE,CAAC,4BAA4B,aAAa,EAAE,CAAC,oBAAoB,kCAAkC,EAAE","sourcesContent":["  .wb-footer {\n    position: relative;\n    overflow: hidden;\n    background: linear-gradient(135deg, #07131f 0%, #0b1c2d 50%, #09111c 100%);\n    color: white;\n    padding-top: 80px;\n    border-top: 1px solid rgba(255,255,255,0.08);\n  }\n  \n  /* glow */\n  .wb-footer-glow{\n    position:absolute;\n    inset:0;\n    background:\n      radial-gradient(circle at 20% 20%, rgba(28,122,180,.18), transparent 35%),\n      radial-gradient(circle at 80% 40%, rgba(243,90,14,.15), transparent 35%),\n      radial-gradient(circle at 50% 100%, rgba(28,122,180,.12), transparent 45%);\n    filter: blur(80px);\n    pointer-events:none;\n  }\n  \n  .wb-footer-content{\n    position:relative;\n    z-index:2;\n    width:90%;\n    max-width:1400px;\n    margin:auto;\n    display:grid;\n    grid-template-columns: 2fr 1fr 1fr 1fr;\n    gap:60px;\n    padding-bottom:50px;\n  }\n  \n  /* brand */\n  .wb-footer-brand img{\n    width:180px;\n    margin-bottom:20px;\n  }\n  \n  .wb-footer-brand p{\n    color:#c7d2de;\n    line-height:1.8;\n    max-width:420px;\n    font-size:15px;\n  }\n  \n  /* columns */\n  .wb-footer-column h3{\n    margin-bottom:22px;\n    font-size:20px;\n    color: var(--primary-100);\n    position:relative;\n  }\n  \n  .wb-footer-column h3::after{\n    content:\"\";\n    position:absolute;\n    left:0;\n    bottom:-8px;\n    width:50px;\n    height:3px;\n    border-radius:10px;\n    background: var(--primary-100);\n    /* background: linear-gradient(90deg,#1c7ab4,#f35a0e); */\n  }\n  \n  .wb-footer-column a,\n  .wb-footer-column p{\n    display:block;\n    text-decoration:none;\n    color:#d7e1eb;\n    margin-bottom:14px;\n    transition:.25s;\n    width:fit-content;\n  }\n  \n  .wb-footer-column a:hover{\n    color:#f35a0e;\n    transform:translateX(6px);\n  }\n  \n  /* socials */\n  .wb-footer-socials{\n    display:flex;\n    gap:15px;\n    margin-top:25px;\n  }\n  \n  .wb-footer-socials a{\n    width:45px;\n    height:45px;\n    border-radius:50%;\n    display:flex;\n    align-items:center;\n    justify-content:center;\n    color:white;\n    font-size:18px;\n    text-decoration:none;\n    background: rgba(255,255,255,.06);\n    border:1px solid rgba(255,255,255,.1);\n    backdrop-filter: blur(10px);\n    transition:.3s;\n  }\n  \n  .wb-footer-socials a:hover{\n    transform:translateY(-6px) scale(1.08);\n    background: var(--primary-100);\n    /* background: linear-gradient(135deg,#1c7ab4,#f35a0e); */\n    box-shadow:0 0 25px rgba(243,90,14,.35);\n  }\n  \n  /* bottom */\n  .wb-footer-bottom{\n    position:relative;\n    z-index:2;\n    text-align:center;\n    padding:25px;\n    border-top:1px solid rgba(255,255,255,.08);\n    color:#9fb1c3;\n    font-size:14px;\n    background: rgba(255,255,255,.02);\n  }\n  \n  /* responsive */\n  @media(max-width:1000px){\n    .wb-footer-content{\n      grid-template-columns:1fr 1fr;\n      gap:40px;\n    }\n  }\n  \n  @media(max-width:700px){\n    .wb-footer{\n      padding-top:50px;\n    }\n  \n    .wb-footer-content{\n      grid-template-columns:1fr;\n      text-align:center;\n    }\n  \n    .wb-footer-brand p{\n      margin:auto;\n    }\n  \n    .wb-footer-socials{\n      justify-content:center;\n    }\n  \n    .wb-footer-column a,\n    .wb-footer-column p{\n      margin-inline:auto;\n    }\n  \n    .wb-footer-column h3::after{\n      left:50%;\n      transform:translateX(-50%);\n    }\n  }\n\n.wb-footer { background:#020617; border-top:1px solid rgba(103,232,249,.18); padding-top:100px; }.wb-footer-glow { background:radial-gradient(circle at 15% 15%, rgba(34,211,238,.16), transparent 29%),radial-gradient(circle at 78% 45%, rgba(99,102,241,.18), transparent 31%); }\n.wb-footer-brand p,.wb-footer-column a,.wb-footer-column p { color:#9caec5; }.wb-footer-column h3 { color:#a5f3fc; }.wb-footer-column h3::after { height:1px; width:64px; background:linear-gradient(90deg,#22d3ee,transparent); }.wb-footer-column a:hover { color:#67e8f9; }.wb-footer-bottom { border-color:rgba(125,211,252,.13); color:#71829a; }\n\n.wb-footer { border-top-color:rgba(224,148,110,.2); }.wb-footer-glow { background:radial-gradient(circle at 15% 15%,rgba(233,90,19,.16),transparent 29%),radial-gradient(circle at 78% 45%,rgba(78,119,153,.2),transparent 31%); }.wb-footer-brand p,.wb-footer-column a,.wb-footer-column p { color:#94a9ba; }.wb-footer-column h3 { color:#e0946e; }.wb-footer-column h3::after { background:linear-gradient(90deg,#e95a13,transparent); }.wb-footer-column a:hover { color:#e0946e; }.wb-footer-bottom { border-color:rgba(148,169,186,.16); }\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
